import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';

const StyledSearchContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: '16px',
  padding: '0px 15px 0 15px',
});

const StyledTextInput = styled(TextInput, {
  fontSize: '14px',
});

const StyledSelectInput = styled(SelectInput, {
  fontSize: '14px',
});

export const ProviderTableSearch = ({
  searchValue,
  searchFilter,
  setSearchValue,
  setSearchFilter,
  options,
  isTaxIdNumber,
  isCareProvider,
  isDisabled,
  isError,
}) => {
  return (
    <StyledSearchContainer>
      <StyledTextInput
        isClearable
        placeholder={isTaxIdNumber ? 'Filter by tax ID' : 'Filter by name'}
        label='Name'
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onClear={() => setSearchValue('')}
        isDisabled={isDisabled || isError}
        data-testid='provider-drawer-search-input-field'
      />
      <If condition={!isTaxIdNumber}>
        <StyledSelectInput
          label={isCareProvider ? 'Status' : 'Access'}
          value={searchFilter}
          width='40%'
          onChange={setSearchFilter}
          options={options}
          isDisabled={isDisabled || isError}
          data-testid='corporate-search-access-status-filter'
        />
      </If>
    </StyledSearchContainer>
  );
};

ProviderTableSearch.propTypes = {
  searchValue: PropTypes.string.isRequired,
  searchFilter: PropTypes.string,
  setSearchValue: PropTypes.func.isRequired,
  setSearchFilter: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  isTaxIdNumber: PropTypes.bool,
  isDisabled: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  isCareProvider: PropTypes.bool,
};

ProviderTableSearch.defaultProps = {
  isTaxIdNumber: false,
  isCareProvider: false,
  searchFilter: '',
  setSearchFilter: () => {},
  options: [],
  isError: false,
};
